import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InovaMapHeper, MobileQuery } from 'inova-front-core/helpers/clases';
import { MAP_CENTER } from 'inova-front-core/constants';

@Component({
  selector: 'inova-delimitation-view',
  templateUrl: './delimitation-view.component.html',
  styleUrls: ['./delimitation-view.component.scss']
})

export class DelimitationViewComponent extends MobileQuery{
  mapPolygons: google.maps.Polygon[] = [];
  regionObj = {
    name: "",
    color: "#111111",
    region: "",
    id: ''
  }

  points: any = [];
  title: any;
  delimitationDescriptors: any = [];
  @ViewChild('mapContainer') gmap: ElementRef | null = null;
  map: google.maps.Map| null = null;
  mapOptions: google.maps.MapOptions = {
    zoom: 12,
    mapTypeControlOptions: {
      position: google.maps.ControlPosition.TOP_RIGHT
    },
    fullscreenControl: true,
    fullscreenControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER
    },
    disableDefaultUI: true,
    zoomControl: true,
    mapTypeId: google.maps.MapTypeId.HYBRID
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    this.title = this.data.title;
    if (data && data.points && data.points.length > 0) {
      this.points = data.points;
    }
    if (data.delimitationDescriptors && data.delimitationDescriptors.length > 0) {
      this.delimitationDescriptors = data.delimitationDescriptors;
      this.regionObj = this.delimitationDescriptors[0];
    }
  }

  ngAfterViewInit(): void {
    this.mapInitializer();
    this.setCurrentValue();
  }

  mapInitializer() {
    this.getPositionGps();
    this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
  }

  setCurrentValue() {
    if (typeof this.points === 'string' || this.points instanceof String) {
      this.points = this.points.split(",");
    }
    if (this.points && this.points.length > 0) {
      let numPolygons = this.getNumPolygons();
      let polygons:any[] = [];
      numPolygons.forEach((numPolygon:any) => {
        let points:any[] = [];
        this.points.forEach((point:any) => {
          let first = point.split(" ", 5);
          let index = first[2] && first[2] != undefined ? first[2].substring(0, 1) : "1";
          if (numPolygon == index) {
            points.push(point);
          }
        });
        if (points.length > 0) {
          polygons.push(points);
        }
      });
      this.drawPolygons(polygons);
    }
  }

  drawPolygons(polygons:any[]) {
    if (polygons && polygons.length > 0) {
      polygons.forEach(polygon => {
        let coords:any[] = [];
        let properties:any = {
          color: 'black'
        };

        if(polygon.length>0){
          const pp=InovaMapHeper.getPositionByPointWithDescriptors(polygon[0]);
          if(pp.color){
            properties['color']=pp.color;
          }
          if(pp.type){
            properties['type']=pp.type;
          }
        }
        polygon.forEach((point:any) => {
          const pp=InovaMapHeper.getPositionByPointWithDescriptors(point);
          coords.push(pp);
        });
        let polygonGP:any = new google.maps.Polygon({ paths: coords, fillColor: properties['color'], fillOpacity: 0.5 });
        polygonGP.setMap(this.map);
        polygonGP['id'] = properties['type'];
        polygonGP['coords']=coords;
        this.mapPolygons.push(polygonGP);
      });
      this.centerDelimitation(this.mapPolygons[0]);
    }
  }

  getNumPolygons() {
    let numPolygons:any[] = [];
    this.points.forEach((point:any) => {
      if (point.includes("(")) {
        let first = point.split(" ", 5);
        let index = first[2] && first[2] != undefined ? first[2].substring(0, 1) : "1";
        numPolygons.push(index);
      }
    });
    numPolygons = this.removeDuplicates(numPolygons);
    return numPolygons;
  }

  removeDuplicates(arr:any[]) {
    return arr.filter((item,index) => arr.indexOf(item) === index);
  }


  async getPositionGps() {
    var position:any = await getPosition();
    if (position == "error") {
      this.map.setOptions({ center: MAP_CENTER });
    } else {
      this.map.setOptions({ center: new google.maps.LatLng(position['coords'].latitude, position['coords'].longitude) });
    }
  }

  centerDelimitation(item: any) {
    if (item.coords?.length > 0) {
      const bounds = new google.maps.LatLngBounds();
      for (const point of item.coords) {
        bounds.extend(point);
      }
      if (!bounds.isEmpty()) {
        this.map.fitBounds(bounds);
      }
    }
  }
}

function getPosition() {
  return new Promise((res, rej) => {
    navigator.geolocation.getCurrentPosition(res, rej);
  }).catch(function (error) {
    return "error"
  });
}
